module.exports = __webpack_public_path__ + "static/media/service-block-1@4x.595a6a85.jpg";